import { render } from "./BaseButtonForms.vue?vue&type=template&id=1bbca7fa"
import script from "./BaseButtonForms.vue?vue&type=script&lang=js"
export * from "./BaseButtonForms.vue?vue&type=script&lang=js"

import "./BaseButtonForms.vue?vue&type=style&index=0&id=1bbca7fa&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__